import { useEffect } from 'react';
import { selectAnyRequestStatus, getItems } from '../../../entities/product/model';
import 'moment/locale/ru';
import { fetchAllPrices } from '../../../entities/price/model';
import { getCart, selectCartStatus } from '../../../entities/cart/model';
import { selectOrdersStatus, fetchAllOrders } from '../../../entities/order/model';
import { selectUsersStatus, fetchAllUsers } from '../../../entities/user/model';
import {
  fetchAllLegalEntities,
  selectLegalEntityStatus,
} from '../../../entities/legal-entity/model';
import { useAppDispatch, useAppSelector } from '../../../app/store/store';
import { useMe } from '../../Area/Area';

export default function useDashboardEffects() {
  const catalogStatus = useAppSelector((state) =>
    selectAnyRequestStatus(state, 'getItems')
  );
  const ordersStatus = useAppSelector(selectOrdersStatus);
  const getPriceListStatus = useAppSelector((state) =>
    selectAnyRequestStatus(state, 'getPriceList')
  );
  const fetchManagersStatus = useAppSelector(selectUsersStatus);
  const companiesStatus = useAppSelector(selectLegalEntityStatus);
  const cartStatus = useAppSelector(selectCartStatus);
  const dispatch = useAppDispatch();
  const { me } = useMe();
  useEffect(() => {
    if (fetchManagersStatus !== 'succeeded') {
      dispatch(fetchAllUsers());
    }
  }, [dispatch]);

  useEffect(() => {
    if (companiesStatus !== 'succeeded') {
      dispatch(fetchAllLegalEntities());
    }
  }, [dispatch]);

  useEffect(() => {
    if (cartStatus !== 'succeeded') {
      dispatch(getCart());
    }
  }, [dispatch]);

  useEffect(() => {
    if (ordersStatus !== 'succeeded') {
      dispatch(fetchAllOrders());
    }
  }, [dispatch]);

  useEffect(() => {
    if (getPriceListStatus !== 'succeeded') {
      dispatch(fetchAllPrices());
    }
  }, [dispatch]);

  useEffect(() => {
    if (catalogStatus !== 'succeeded') {
      dispatch(getItems());
    }
  }, [dispatch, me.id]);
}
